const dev = {
  s3: {
    REGION: "us-east-1",
    BUCKET: "reader-library-storage"
  },
  s3Image: {
    REGION: "us-east-1",
    BUCKET: "bookchain-dev-covers-20180827203217699500000002"
  },
  cognito: {
    APP_CLIENT_ID: "2f3kgt3uk1effp9ge7v3nc8sbg",
    IDENTITY_POOL_ID: "us-east-1:950c12e5-8757-4c3f-9b3e-56a738fdba9f",
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_NXNZv6a8G"
  }
};

const prod = {
  s3: {
    REGION: "us-east-1",
    BUCKET: "reader-library-storage"
  },
  s3Image: {
    REGION: "us-east-1",
    BUCKET: "bookchain-prod-covers-20180827203217699500000002"
  },
  cognito: {
    APP_CLIENT_ID: "75il2fgqo1mnqc4mtspjmulbhi",
    IDENTITY_POOL_ID: "us-east-1:3cf436f5-5033-437d-9ee8-053123abc2f5",
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_QSgWVBFIe"
  }
};

const config = process.env.REACT_APP_STAGE === "prod"
  ? prod
  : dev;

export default {
  ...config
};
